import Service from "@/utils/api/service";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "CreateDeliveryCondition",
  data() {
    return {
      isCreating: false,
      body: {
        name: "",
        description: "",
        status: "active",
        type: "free",
        baseDeliveryFee: null,
        conditions: [],
        basicDistanceKm: null,
        basicDistanceFee: null,
        isFreeDeliveryOnMinOrderAmount: false,
        freeDeliveryOnMinOrderAmount: null,
        isExpressDelivery: false,
        expressDeliveryType: "fixed amount",
        expressDeliveryFee: null,
        districtAction: "include",
        districtIds: [],
        customerGroupAction: "include",
        customerGroupIds: [],
        customerAction: "include",
        customerIds: [],
      },
      popupTypes: [
        { id: 1, name: "Immediately" },
        { id: 2, name: "After second" },
      ],
      loading: {
        isCreating: false,
        isSearching: false,
      },
      customers: [],
      customerGroups: this.$master?.customerGroups || [],
      allCustomerGroups: this.$master?.customerGroups || [],
      districts: [],
      allDistricts: [],
      actions: [
        { id: "include", name: "Include" },
        { id: "exclude", name: "Exclude" },
      ],
      standardDeliveryFeeTypes: [
        { id: "free", name: "Free" },
        { id: "fixed amount", name: "Fixed Amount" },
        { id: "condition", name: "Based on conditions" },
      ],
      expressDeliveryTypes: [
        { id: "fixed amount", name: "Fixed Amount" },
        { id: "percentage", name: "Percentage" },
      ],
    };
  },
  components: {
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
    debouncedOnSearchDistricts() {
      return _debounce(this.searchDistricts, 500);
    },
    debouncedOnSearchCustomers() {
      return _debounce(this.searchCustomers, 500);
    },
    debouncedOnSearchCustomerGroups() {
      return _debounce(this.searchCustomerGroups, 500);
    },
    districtOptions() {
      return this.districts.map((c) => ({
        ...c,
        displayName: `${c.name || ""}`.trim(),
      }));
    },
    customerOptions() {
      return this.customers.map((c) => ({
        ...c,
        displayName: c?.bpName
          ? `${c?.bpName} ( ${c?.code} )`
          : !c.firstName && !c.lastName && c?.bpName
          ? `${c?.bpName} ( ${c?.code} )`
          : `${c?.firstName || ""} ${c?.lastName || ""} ( ${c?.code} )`.trim(),
      }));
    },
    customerGroupOptions() {
      return this.customerGroups.map((c) => ({
        ...c,
        displayName: `${c.name || ""}`.trim(),
      }));
    },
  },
  created() {
    setTimeout(() => {
      this.getDistricts();
      this.searchCustomers();
      this.searchCustomerGroups();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListDeliveryCondition",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    // codition action
    onAddNewAction() {
      const item = { extendMinKm: null, extendMaxKm: null, feePerKm: null };

      this.body.conditions.push(item);
    },

    onDeleteAction(index) {
      this.body.conditions.splice(index, 1);
    },

    // validation
    onChangeExpress() {
      // reset express condition
      this.body.expressDeliveryType = "fixed amount";
      this.body.expressDeliveryFee = null;
    },

    onChangeStandard() {
      // reset standard condition
      if (this.body.type === "fixed amount") {
        this.body.conditions = [];
        this.body.isFreeDeliveryOnMinOrderAmount = false;
        this.body.freeDeliveryOnMinOrderAmount = null;
        this.body.basicDistanceKm = null;
        this.body.basicDistanceFee = null;
      } else if (this.body.type === "condition") {
        this.body.baseDeliveryFee = null;
        if (this.body.conditions && !this.body.conditions.length) {
          this.body.conditions = [
            { extendMinKm: null, extendMaxKm: null, feePerKm: null },
          ];
        }
      } else {
        this.body.baseDeliveryFee = null;
        this.body.basicDistanceKm = null;
        this.body.basicDistanceFee = null;
        this.body.conditions = [];
        this.body.isFreeDeliveryOnMinOrderAmount = false;
        this.body.freeDeliveryOnMinOrderAmount = null;
      }
    },

    onChangeIsFree() {
      // reset free condition
      this.body.freeDeliveryOnMinOrderAmount = null;
    },

    // search
    searchDistricts(query) {
      if (!query || query.trim() === "") {
        this.districts = [...this.allDistricts];
        return;
      }

      this.filterDistrict(this.allDistricts, query);
    },

    filterDistrict(data, search) {
      if (!search || search.trim() === "") {
        this.districts = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.districts = items;
    },

    async getDistricts() {
      let params = "?all=true";
      await Service.getDistrict(params).then((response) => {
        this.loading.isSearching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getDistricts();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.districts = response?.data;
          this.allDistricts = response?.data;
        }
      });
    },

    async searchCustomers(query) {
      if (!this.checkoutPermission("LIST_CUSTOMER_ACCOUNT")) return;

      this.loading.isSearching = true;
      let search = { search: query };
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        limit: 30,
        status: "active",
        ...search,
      });
      let params = this.$helper.queryParam(setQuery);

      await Service.getCustomers(params).then((response) => {
        this.loading.isSearching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.searchCustomers();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.customers = response?.data;
        }
      });
    },

    searchCustomerGroups(query) {
      if (!query || query.trim() === "") {
        this.customerGroups = [...this.allCustomerGroups];
        return;
      }

      this.filterCustomerGroup(this.allCustomerGroups, query);
    },

    filterCustomerGroup(data, search) {
      if (!search || search.trim() === "") {
        this.customerGroups = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.customerGroups = items;
    },

    onSubmit() {
      let validatedMessage = this.validateBody(this.body);

      if (validatedMessage == "ok") {
        this.isCreating = true;
        this.onConfirm();
      } else {
        this.$toasted.show(validatedMessage);
      }
    },

    validateBody(data) {
      if (!data.name) {
        return "Condition Name cannot be empty!";
      }

      if (data.districtIds && !data.districtIds.length) {
        return "Districts cannot be empty!";
      }

      if (
        data.type === "fixed amount" &&
        (Number(data.baseDeliveryFee) <= 0 ||
          isNaN(Number(data.baseDeliveryFee)))
      ) {
        return "Fixed Amount cannot be empty or zero!";
      }

      if (data.type === "condition") {
        if (
          Number(data.basicDistanceKm) <= 0 ||
          isNaN(Number(data.basicDistanceKm))
        ) {
          return "Maximum Kilometer cannot be empty or zero!";
        }

        if (
          typeof data.basicDistanceFee === "string" ||
          data.basicDistanceFee < 0 ||
          data.basicDistanceFee === null
        ) {
          return "Fixed Fee cannot be empty!";
        }

        if (Array.isArray(data.conditions)) {
          for (let i = 0; i < data.conditions.length; i++) {
            const condition = data.conditions[i];
            const extendMinKm = Number(condition.extendMinKm);
            const extendMaxKm = Number(condition.extendMaxKm);
            const feePerKm = condition.feePerKm;

            if (isNaN(extendMinKm) || extendMinKm <= 0) {
              return `Extended Distance ${
                i + 1
              }: Min. Kilometer cannot be empty or zero!`;
            }

            if (isNaN(extendMaxKm) || extendMaxKm <= 0) {
              return `Extended Distance ${
                i + 1
              }: Max. Kilometer cannot be empty or zero!`;
            }

            if (
              typeof feePerKm === "string" ||
              feePerKm < 0 ||
              feePerKm === null
            ) {
              return `Extended Distance ${i + 1}: Fee per KM cannot be empty!`;
            }

            if (extendMinKm >= extendMaxKm) {
              return `Extended Distance ${
                i + 1
              }: Min. Kilometer cannot be greater or equal to Max. Kilometer!`;
            }
          }
        }

        if (
          data.isFreeDeliveryOnMinOrderAmount &&
          (Number(data.freeDeliveryOnMinOrderAmount) <= 0 ||
            isNaN(Number(data.freeDeliveryOnMinOrderAmount)))
        ) {
          return "Minimum order amount cannot be empty or zero!";
        }
      }

      if (data.isExpressDelivery) {
        const fee = Number(data.expressDeliveryFee);
        if (fee <= 0 || isNaN(fee)) {
          return "Express delivery fee cannot be empty or zero!";
        }

        if (data.expressDeliveryType === "percentage" && fee > 99) {
          return "Express delivery fee cannot be greater than 99%!";
        }
      }

      return "ok";
    },

    transformBody(originalBody) {
      const transformedBody = { ...originalBody };

      transformedBody.districtIds = (originalBody.districtIds ?? []).map(
        (district) => district.districtId
      );
      transformedBody.customerGroupIds = (
        originalBody.customerGroupIds ?? []
      ).map((group) => group.id);
      transformedBody.customerIds = (originalBody.customerIds ?? []).map(
        (customer) => customer.id
      );

      return transformedBody;
    },

    onConfirm() {
      Service.createDeliveryCondition(this.transformBody(this.body)).then(
        (response) => {
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.onConfirm();
                }
              });
            } else {
              this.isCreating = false;
              this.$toasted.show(response.message);
            }
          } else {
            this.isCreating = false;
            this.resetBody();
            this.$toasted.show("Delivery Condition has been created.");
            this.goBack();
          }
        }
      );
    },

    resetBody() {
      this.body = {
        name: "",
        description: "",
        status: "active",
        type: "free",
        baseDeliveryFee: null,
        conditions: [],
        basicDistanceKm: null,
        basicDistanceFee: null,
        isFreeDeliveryOnMinOrderAmount: false,
        freeDeliveryOnMinOrderAmount: null,
        isExpressDelivery: false,
        expressDeliveryType: "fixed amount",
        expressDeliveryFee: null,
        districtAction: "include",
        districtIds: [],
        customerGroupAction: "include",
        customerGroupIds: [],
        customerAction: "include",
        customerIds: [],
      };
    },
  },
};
